import { paypalButtonModalActionMaker } from '@website/components/ActionMakers'

export default dispatcher => ({
  getPayPalButtonActions: paypalButtonModalActionMaker(dispatcher)
})
